const queue = new Set();

function addToQueue(metric) {
    queue.add(metric);
}

function flushQueue() {
    if (queue.size > 0) {
        queue.forEach(element => {
            process(element);
        });

        const headers = {
            'X-CSRF-TOKEN': document.head.querySelector("[name~=csrf-token][content]").content
        };
        const body = JSON.stringify([...queue]);

        fetch('/web-vitals', {
            body,
            method: 'POST',
            headers: headers,
            keepalive: true
        });

        queue.clear();
    }
}

function process(obj) {
    let dlObj = {event: 'web-vitals', webVitalsMeasurement: {}};
    let cwvObj = {
      name: obj.name,
      id: obj.id,
      value: obj.value,
      delta: obj.delta,
      valueRounded: Math.round(obj.name === 'CLS' ? obj.value * 1000 : obj.value),
      deltaRounded: Math.round(obj.name === 'CLS' ? obj.delta * 1000 : obj.delta),
      rating: obj.rating,
      element: '',
      eventType: '',
    };
    
    if (obj.name === 'INP' || obj.name === 'FID') {
      cwvObj.element = obj.attribution.eventTarget,
      cwvObj.eventType = obj.attribution.eventType
    }
    
    if (obj.name === 'LCP') {
      cwvObj.element = obj.attribution.element;
    }
    
    if (obj.name === 'CLS') {
      cwvObj.element = obj.attribution.largestShiftTarget;
    }
    
    dlObj.webVitalsMeasurement = cwvObj;
    
    // Push dataLayer event if available 
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push(dlObj);
    }
};

/**
 * Execute web vital listeners
 */
(function () {
    var script = document.createElement('script');
    script.src =
        'https://unpkg.com/web-vitals@3/dist/web-vitals.attribution.iife.js';
    script.defer = true;
    script.onload = function () {
        webVitals.onCLS(addToQueue);
        webVitals.onFID(addToQueue);
        webVitals.onLCP(addToQueue);
        webVitals.onINP(addToQueue);
        webVitals.onFCP(addToQueue);
        webVitals.onTTFB(addToQueue);
    };
    document.head.appendChild(script);
})();

/**
 * Report all available metrics whenever the page is 
 * backgrounded or unloaded.
 */
addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
        flushQueue();
    }
});

/**
 * Event listener for Safari browsers that don't fire
 * the `visibilitychange` event reliably
 */
addEventListener('pagehide', flushQueue);
